import React, { useEffect, useState } from 'react';
import YouTubeIcon from '@mui/icons-material/YouTube';
import FacebookIcon from '@mui/icons-material/Facebook';
import scaLogo from '../../../assets/Images/Logos/SCALogo.png';
import './Footer.css';
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

const Footer = () => {
  const [isFooterLoaded, setIsFooterLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsFooterLoaded(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  if (!isFooterLoaded) {
    return null;
  }

  const openUrl = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const links = {
    youTubePage: 'https://www.youtube.com/@saintcatherineacademy1980',
    facebookPage: 'https://www.facebook.com/SCAHighSchoolBelize',
    scaPage: 'https://www.sca.edu.bz/',
  };

  return (
    <footer className="footer">
      <ul className='footerItem'>
        <li style={{marginTop: "10px"}}>Saint Catherine Academy &copy; {new Date().getFullYear()}</li>
      </ul>
      <ul className='footer-social-media-icon'>
        <li>
          <YouTubeIcon onClick={() => openUrl(links.youTubePage)} style={{ marginRight: '20px' }} />
        </li>
        <li>
          <FacebookIcon onClick={() => openUrl(links.facebookPage)} style={{ color: "blue", marginLeft: '0px', marginRight: '18px' }} />
        </li>
        <li>
          <img className='scaFooterLogo' src={scaLogo} alt='SCA Footer Link' onClick={() => openUrl(links.scaPage)} style={{ height: "40px", borderRadius: "50%", marginTop: "25.25px" }} />
        </li>
      </ul>
    </footer>
  );
};

export default Footer;
